import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import insta from './insta.png';
import phon from './phon.svg';
import { contx } from '../../App';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { lang } = React.useContext(contx);

  return (
    <>
      <div className="p-3" style={{ width: '100%', backgroundColor: '#005247', color: 'white' }}>
        <Container>
          <Row>
            <Col md={2}>
              {/*<img src={logo} width={200} alt="logo" />*/}
              <p style={{ fontSize: '15px' }}>
                {lang === 'en'
                  ? 'Tatweer Company for Training, Qualification, Project Management, and Financial Technology (FinTech)'
                  : 'شركة تطوير للتدريب والتأهيل وإدارة المشاريع والتكنولوجيا المالية (فينتك)'}
              </p>
            </Col>
            <Col md={10} className="m-auto">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: '55px',
                }}
              >
                <a
                  href="https://www.instagram.com/tatweer.iq?igsh=MXZjcHhycDBqMjRodQ=="
                  style={{ color: 'white', textDecoration: 'none' }}
                >
                  <img src={insta} width={30} alt="instagram" />
                  <p>tatweer.iq</p>
                </a>
                <a href="tel:+9647834887998" style={{ color: 'white', textDecoration: 'none' }}>
                  <img src={phon} width={30} alt="phone" />
                  <p>07834887998</p>
                </a>
                <a href="mailto:support@tatweer-iq.net" style={{ color: 'white', textDecoration: 'none' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="#8BF35E"
                    aria-hidden="true"
                  >
                    <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4.2-8 5-8-5V6l8 5 8-5v2.2Z" />
                  </svg>
                  <p>support@tatweer-iq.net</p>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
        <hr />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            marginBottom: '10px',
          }}
        >
          <Link to="/privacy" style={{ color: '#cecece', textDecoration: 'none', fontSize: '14px' }}>
            {lang === 'en' ? 'Privacy Policy' : 'سياسة الخصوصية'}
          </Link>
          <span style={{ color: '#cecece' }}>|</span>
          <Link to="/support" style={{ color: '#cecece', textDecoration: 'none', fontSize: '14px' }}>
            {lang === 'en' ? 'Support' : 'الدعم'}
          </Link>
          <span style={{ color: '#cecece' }}>|</span>
          <Link to="/marketing" style={{ color: '#cecece', textDecoration: 'none', fontSize: '14px' }}>
            {lang === 'en' ? 'Marketing' : 'التسويق'}
          </Link>
        </div>
        <p
          className="m-0 p-0"
          style={{ textAlign: 'center', color: '#cecece' }}
        >
          Copyright © 2024 Tatweer. All rights reserved.
        </p>
      </div>
    </>
  );
};

export default Footer;
